import { SlideOverActor } from 'xstate/actors/SlideOverActor';
import { StateValue } from 'xstate/machines/SlideOverMachine';
import { useSelector } from '@xstate/react';

interface UseSlideOverResult {
  slideOverState: ReturnType<typeof SlideOverActor.getSnapshot>;
  isClosed: boolean;
  isOpen: boolean;
  view: any;
  payload: any;
}

/**
 * This hook wraps the SlideOver Service with a few convenience helpers. Destructuring allows to
 * keep the consumer's logic minimal.
 */
export const useSlideOver = (): UseSlideOverResult => {
  const slideOverState = useSelector(SlideOverActor, (snapshot) => snapshot);

  // State Helpers
  const isClosed = slideOverState.matches(StateValue.Closed);
  const isOpen = slideOverState.matches(StateValue.Open);

  // Context Helpers
  const view = slideOverState.context.view;
  const payload = slideOverState.context.payload;

  return {
    slideOverState,
    isClosed,
    isOpen,
    view,
    payload,
  };
};
